import { login, logout, getInfo ,listcateall} from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { stringToBase64AES } from '@/utils/help'

const user = {
  state: {
    token: getToken(),
    name: '',
    userid: '',
    username: '',
    avatar: '',
    departId:'',
    special: '',
    roles: [],
    menus: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERID: (state, userid) => {
      state.userid = userid
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_DEPART_ID: (state, departId) => {
      state.departId = departId
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_SPECIAL: (state, special) => {
      state.special = special
    }

  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, stringToBase64AES(userInfo.password),userInfo.code,userInfo.sid).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr);
          listcateall().then(res => {
            //获取所有参数保存本地缓存
            window.localStorage.setItem('VALUECODE', JSON.stringify(res.data));
            })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data;
          window.localStorage.setItem('USERINFO', JSON.stringify(data));
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('用户无角色权限')
          }
          commit('SET_USERID', data.userid)
          commit('SET_MENUS', data.menus)
          commit('SET_USERNAME', data.username)
          commit('SET_NAME', data.nickname)
          commit('SET_AVATAR', data.icon)
          commit('SET_SPECIAL', data.special)
          commit('SET_DEPART_ID', data.departId)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 单点登录
    TokenLogin({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', getToken())
        getInfo().then(response => {
          const data = response.data;
          window.localStorage.setItem('USERINFO', JSON.stringify(data));
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_MENUS', data.menus)
          commit('SET_USERNAME', data.username)
          commit('SET_NAME', data.nickname)
          commit('SET_AVATAR', data.icon)
          commit('SET_SPECIAL', data.special)
          commit('SET_DEPART_ID', data.departId)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_SPECIAL', '')
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js